import type { RouteObject } from 'react-router';
import { RequerPermissao } from '@/app/RequerPermissao';
import { paginaSobDemanda } from '@/app/pagina-sob-demanda';

/**
 * Rotas do módulo Análise Financeira (iteração 17.10).
 *
 * 🚨 **Não há rota de lista nem item de menu, e isso é decisão** (17.9): a análise é **da empresa** mas vive
 * numa **aba do lead**, onde o trabalho acontece. Uma página solta `/analise-financeira` obrigaria a escolher
 * a empresa antes de ter contexto.
 *
 * O que existe aqui são as telas de **revisão** de uma demonstração, que não cabem numa aba — a do Balanço
 * tem 37 campos mais a transcrição. Elas ficam sob `/leads/:id/` porque é de lá que a pessoa vem e para lá
 * que ela volta, e sob `RequerPermissao` como rota-mãe: segunda tranca, a que vale é o `@Permissao()` do
 * backend. `.../novo` vem **antes** da rota com id — o roteador ranqueia por especificidade de qualquer
 * forma, a ordem é para quem lê.
 */
export const rotas: RouteObject[] = [
  {
    element: <RequerPermissao permissao="leads.ver" />,
    children: [
      {
        element: <RequerPermissao permissao="analise_financeira.ver" />,
        children: [
          {
            path: '/leads/:id/dres/novo',
            element: paginaSobDemanda(
              () => import('./paginas/PaginaRevisarDre'),
              (m) => m.PaginaRevisarDre,
              'Abrindo o lançamento da DRE…',
            ),
          },
          {
            path: '/leads/:id/dres/:dreId',
            element: paginaSobDemanda(
              () => import('./paginas/PaginaRevisarDre'),
              (m) => m.PaginaRevisarDre,
              'Abrindo a DRE…',
            ),
          },
          {
            path: '/leads/:id/balancos/novo',
            element: paginaSobDemanda(
              () => import('./paginas/PaginaRevisarBalanco'),
              (m) => m.PaginaRevisarBalanco,
              'Abrindo o lançamento do Balanço…',
            ),
          },
          {
            path: '/leads/:id/balancos/:balancoId',
            element: paginaSobDemanda(
              () => import('./paginas/PaginaRevisarBalanco'),
              (m) => m.PaginaRevisarBalanco,
              'Abrindo o Balanço…',
            ),
          },
        ],
      },
    ],
  },
];
